export enum EStopStatus {
  UNKNOWN = 0,
  INACTICE = 1,
  ACTIVE = 2
}
